export const MULTI_COLOR_LOGO_LEGAL_ENTITIES = [
  'CITIEQ',
  'CITIUS',
  'SFR-CITI',
  'BAML',
  'BNPPBIL',
  'BNPPFM',
  'EUROBK',
  'POALIMINT',
  'POALIMISR',
  'SEB',
  'FLTDX',
  'FLTXDG',
  'FLTXDGMS',
  'FREETRAD',
  'TICKRS',
  'WFRONT',
  'BLIL',
  'BLILISR',
  'BLILILS',
  'SAWAED',
  'AWAEDUS',
];
